import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ResponsiveContainer,
  ResponsiveContent,
  ResponsiveHeader,
  ResponsiveFooter,
} from '../ui/ResponsiveLayout';

const Frame234: React.FC = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/frame-235');
  };

  const handleBack = () => {
    navigate('/frame-140');
  };

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <ResponsiveHeader title="Track Debts and Final Expenses" />

        <div className="max-w-4xl space-y-8">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              This is a place to gather important financial details that your loved ones may need
              one day. By organizing outstanding debts and ongoing expenses now, you help reduce
              confusion, stress, and uncertainty during an already difficult time.
            </p>
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              You don’t need to have everything figured out. You can add what you know today and
              return whenever you’re ready.
            </p>
          </div>

          {/* What You'll Do */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">What You’ll Do</h2>
            <div className="space-y-4">
            {/* 1 */}
            <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                1
                </div>
                <div>
                <p className="text-stone-700 font-bold">
                    Record outstanding debts like loans, credit cards, medical bills, and taxes
                </p>
                </div>
            </div>

            {/* 2 */}
            <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                2
                </div>
                <div>
                <p className="text-stone-700 font-bold">
                    Capture recurring expenses that may need to be continued or closed
                </p>
                </div>
            </div>

            {/* 3 */}
            <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                3
                </div>
                <div>
                <p className="text-stone-700 font-bold">
                    Create a clearer financial picture for your executor or family
                </p>
                </div>
            </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">Why This Matters</h2>
            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Helps your loved ones understand what needs attention after you’re gone
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Prevents missed payments, penalties, or unexpected account issues
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Reduces the time and effort required to settle financial obligations
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Gives your executor confidence during a stressful and emotional period
                </span>
              </li>
            </ul>
          </div>

          {/* Estimated Time */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span> Most people spend about 10
              minutes here.
            </p>
            <p className="text-xs mt-1">
              You can save your progress and come back at any time.
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Track Debts and Final Expenses"
        subtitle="Record outstanding debts and expenses"
        progressPercent={0}
        onNext={handleNext}
        onBack={handleBack}
        nextText="Get Started"
        backText="Back to Dashboard"
      />
    </ResponsiveContainer>
  );
};

export default Frame234;